// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__3S1MZ","question":"Question_question__2sSrn","description":"Question_description__2pQ-Z"};